import firebase from 'firebase/app'
import 'firebase/auth';
// import * as auth from "./auth";
import 'firebase/firestore'
import 'firebase/functions'
// import 'firebase/<PACKAGE>';

// firebase utils
// const db = firebase.firestore();
// const auth = firebase.auth();

// Initialize Firebase
var config = {
  apiKey: "AIzaSyDHQwV3MpM_-PCiBlqIt3qNVa-DduCV-34",
  authDomain: "icabody-app.firebaseapp.com",
  databaseURL: "https://icabody-app.firebaseio.com",
  projectId: "icabody-app",
  storageBucket: "icabody-app.appspot.com",
  messagingSenderId: "943693926089"
};
firebase.initializeApp(config);

// export default firebase;
// export {
// db,
// usersCollection,
// postsCollection,
// commentsCollection,
// likesCollection,
//   auth
// };
const auth = firebase.auth();
auth.useDeviceLanguage();
// const currentUser = auth.currentUser;
const firestore = firebase.firestore;
const db = firebase.firestore();
// const settings = { /* your settings... */ timestampsInSnapshots: true };
// db.settings(settings);

export {
  firebase,
  db,
  firestore,
  auth,
};
